import i18n from "@/i18n";

export const getTimezones = () => [
  { value: "Pacific/Midway", label: i18n.t("(UTC-11:00) Midway Island, American Samoa") },
  { value: "America/Adak", label: i18n.t("(UTC-10:00) Aleutian Islands") },
  { value: "Pacific/Honolulu", label: i18n.t("(UTC-10:00) Hawaii") },
  { value: "Pacific/Marquesas", label: i18n.t("(UTC-09:30) Marquesas Islands") },
  { value: "America/Anchorage", label: i18n.t("(UTC-09:00) Alaska") },
  { value: "America/Tijuana", label: i18n.t("(UTC-08:00) Baja California") },
  { value: "America/Los_Angeles", label: i18n.t("(UTC-08:00) Pacific Time (US and Canada)") },
  { value: "America/Phoenix", label: i18n.t("(UTC-07:00) Arizona") },
  { value: "America/Denver", label: i18n.t("(UTC-07:00) Mountain Time (US and Canada), Navajo Nation") },
  { value: "America/Belize", label: i18n.t("(UTC-06:00) Central America") },
  { value: "America/Chicago", label: i18n.t("(UTC-06:00) Central Time (US and Canada)") },
  { value: "America/Chihuahua", label: i18n.t("(UTC-06:00) Chihuahua, La Paz, Mazatlan") },
  { value: "Pacific/Easter", label: i18n.t("(UTC-06:00) Easter Island") },
  { value: "America/Mexico_City", label: i18n.t("(UTC-06:00) Guadalajara, Mexico City, Monterrey") },
  { value: "America/Regina", label: i18n.t("(UTC-06:00) Saskatchewan") },
  { value: "America/Bogota", label: i18n.t("(UTC-05:00) Bogota, Lima, Quito") },
  { value: "America/Cancun", label: i18n.t("(UTC-05:00) Chetumal") },
  { value: "America/New_York", label: i18n.t("(UTC-05:00) Eastern Time (US and Canada)") },
  { value: "America/Port-au-Prince", label: i18n.t("(UTC-05:00) Haiti") },
  { value: "America/Havana", label: i18n.t("(UTC-05:00) Havana") },
  { value: "America/Indiana/Indianapolis", label: i18n.t("(UTC-05:00) Indiana (East)") },
  { value: "America/Asuncion", label: i18n.t("(UTC-04:00) Asuncion") },
  { value: "America/Halifax", label: i18n.t("(UTC-04:00) Atlantic Time (Canada)") },
  { value: "America/Caracas", label: i18n.t("(UTC-04:00) Caracas") },
  { value: "America/Cuiaba", label: i18n.t("(UTC-04:00) Cuiaba") },
  { value: "America/Manaus", label: i18n.t("(UTC-04:00) Georgetown, La Paz, Manaus, San Juan") },
  { value: "America/Santiago", label: i18n.t("(UTC-04:00) Santiago") },
  { value: "America/Grand_Turk", label: i18n.t("(UTC-04:00) Turks and Caicos") },
  { value: "America/St_Johns", label: i18n.t("(UTC-03:30) Newfoundland") },
  { value: "America/Fortaleza", label: i18n.t("(UTC-03:00) Araguaina") },
  { value: "America/Sao_Paulo", label: i18n.t("(UTC-03:00) Brasilia") },
  { value: "America/Cayenne", label: i18n.t("(UTC-03:00) Cayenne, Fortaleza") },
  { value: "America/Buenos_Aires", label: i18n.t("(UTC-03:00) City of Buenos Aires") },
  { value: "America/Godthab", label: i18n.t("(UTC-03:00) Greenland") },
  { value: "America/Montevideo", label: i18n.t("(UTC-03:00) Montevideo") },
  { value: "America/Miquelon", label: i18n.t("(UTC-03:00) Saint Pierre and Miquelon") },
  { value: "America/Bahia", label: i18n.t("(UTC-03:00) Salvador") },
  { value: "America/Noronha", label: i18n.t("(UTC-02:00) Fernando de Noronha") },
  { value: "Atlantic/Azores", label: i18n.t("(UTC-01:00) Azores") },
  { value: "Atlantic/Cape_Verde", label: i18n.t("(UTC-01:00) Cabo Verde Islands") },
  { value: "Europe/London", label: i18n.t("(UTC) Dublin, Edinburgh, Lisbon, London") },
  { value: "Africa/Monrovia", label: i18n.t("(UTC) Monrovia, Reykjavik") },
  { value: "Europe/Amsterdam", label: i18n.t("(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna") },
  { value: "Europe/Belgrade", label: i18n.t("(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague") },
  { value: "Europe/Brussels", label: i18n.t("(UTC+01:00) Brussels, Copenhagen, Madrid, Paris") },
  { value: "Europe/Warsaw", label: i18n.t("(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb") },
  { value: "Africa/Algiers", label: i18n.t("(UTC+01:00) West Central Africa") },
  { value: "Africa/Casablanca", label: i18n.t("(UTC+01:00) Casablanca") },
  { value: "Africa/Windhoek", label: i18n.t("(UTC+01:00) Windhoek") },
  { value: "Europe/Athens", label: i18n.t("(UTC+02:00) Athens, Bucharest") },
  { value: "Asia/Beirut", label: i18n.t("(UTC+02:00) Beirut") },
  { value: "Africa/Cairo", label: i18n.t("(UTC+02:00) Cairo") },
  { value: "Asia/Damascus", label: i18n.t("(UTC+02:00) Damascus") },
  { value: "Asia/Gaza", label: i18n.t("(UTC+02:00) Gaza, Hebron") },
  { value: "Africa/Harare", label: i18n.t("(UTC+02:00) Harare, Pretoria") },
  { value: "Europe/Helsinki", label: i18n.t("(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius") },
  { value: "Asia/Jerusalem", label: i18n.t("(UTC+02:00) Jerusalem") },
  { value: "Europe/Kaliningrad", label: i18n.t("(UTC+02:00) Kaliningrad") },
  { value: "Africa/Tripoli", label: i18n.t("(UTC+02:00) Tripoli") },
  { value: "Asia/Amman", label: i18n.t("(UTC+03:00) Amman") },
  { value: "Asia/Baghdad", label: i18n.t("(UTC+03:00) Baghdad") },
  { value: "Asia/Istanbul", label: i18n.t("(UTC+03:00) Istanbul") },
  { value: "Asia/Kuwait", label: i18n.t("(UTC+03:00) Kuwait, Riyadh") },
  { value: "Europe/Minsk", label: i18n.t("(UTC+03:00) Minsk") },
  { value: "Europe/Moscow", label: i18n.t("(UTC+03:00) Moscow, St. Petersburg") },
  { value: "Africa/Nairobi", label: i18n.t("(UTC+03:00) Nairobi") },
  { value: "Asia/Tehran", label: i18n.t("(UTC+03:30) Tehran") },
  { value: "Asia/Muscat", label: i18n.t("(UTC+04:00) Abu Dhabi, Muscat") },
  { value: "Europe/Astrakhan", label: i18n.t("(UTC+04:00) Astrakhan, Ulyanovsk, Volgograd") },
  { value: "Asia/Baku", label: i18n.t("(UTC+04:00) Baku") },
  { value: "Europe/Samara", label: i18n.t("(UTC+04:00) Izhevsk, Samara") },
  { value: "Indian/Mauritius", label: i18n.t("(UTC+04:00) Port Louis") },
  { value: "Asia/Tbilisi", label: i18n.t("(UTC+04:00) Tbilisi") },
  { value: "Asia/Yerevan", label: i18n.t("(UTC+04:00) Yerevan") },
  { value: "Asia/Kabul", label: i18n.t("(UTC+04:30) Kabul") },
  { value: "Asia/Tashkent", label: i18n.t("(UTC+05:00) Tashkent, Ashgabat") },
  { value: "Asia/Yekaterinburg", label: i18n.t("(UTC+05:00) Ekaterinburg") },
  { value: "Asia/Karachi", label: i18n.t("(UTC+05:00) Islamabad, Karachi") },
  { value: "Asia/Almaty", label: i18n.t("(UTC+05:00) Astana") },
  { value: "Asia/Kolkata", label: i18n.t("(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi") },
  { value: "Asia/Colombo", label: i18n.t("(UTC+05:30) Sri Jayawardenepura") },
  { value: "Asia/Katmandu", label: i18n.t("(UTC+05:45) Kathmandu") },
  { value: "Asia/Dhaka", label: i18n.t("(UTC+06:00) Dhaka") },
  { value: "Asia/Rangoon", label: i18n.t("(UTC+06:30) Yangon (Rangoon)") },
  { value: "Asia/Novosibirsk", label: i18n.t("(UTC+07:00) Novosibirsk") },
  { value: "Asia/Bangkok", label: i18n.t("(UTC+07:00) Bangkok, Hanoi, Jakarta") },
  { value: "Asia/Barnaul", label: i18n.t("(UTC+07:00) Barnaul, Gorno-Altaysk") },
  { value: "Asia/Hovd", label: i18n.t("(UTC+07:00) Hovd") },
  { value: "Asia/Krasnoyarsk", label: i18n.t("(UTC+07:00) Krasnoyarsk") },
  { value: "Asia/Tomsk", label: i18n.t("(UTC+07:00) Tomsk") },
  { value: "Asia/Chongqing", label: i18n.t("(UTC+08:00) Beijing, Chongqing, Hong Kong SAR, Urumqi") },
  { value: "Asia/Irkutsk", label: i18n.t("(UTC+08:00) Irkutsk") },
  { value: "Asia/Kuala_Lumpur", label: i18n.t("(UTC+08:00) Kuala Lumpur, Singapore") },
  { value: "Australia/Perth", label: i18n.t("(UTC+08:00) Perth") },
  { value: "Asia/Taipei", label: i18n.t("(UTC+08:00) Taipei") },
  { value: "Asia/Ulaanbaatar", label: i18n.t("(UTC+08:00) Ulaanbaatar") },
  { value: "Asia/Pyongyang", label: i18n.t("(UTC+08:30) Pyongyang") },
  { value: "Australia/Eucla", label: i18n.t("(UTC+08:45) Eucla") },
  { value: "Asia/Chita", label: i18n.t("(UTC+09:00) Chita") },
  { value: "Asia/Tokyo", label: i18n.t("(UTC+09:00) Osaka, Sapporo, Tokyo") },
  { value: "Asia/Seoul", label: i18n.t("(UTC+09:00) Seoul") },
  { value: "Asia/Yakutsk", label: i18n.t("(UTC+09:00) Yakutsk") },
  { value: "Australia/Adelaide", label: i18n.t("(UTC+09:30) Adelaide") },
  { value: "Australia/Darwin", label: i18n.t("(UTC+09:30) Darwin") },
  { value: "Australia/Brisbane", label: i18n.t("(UTC+10:00) Brisbane") },
  { value: "Australia/Canberra", label: i18n.t("(UTC+10:00) Canberra, Melbourne, Sydney") },
  { value: "Pacific/Guam", label: i18n.t("(UTC+10:00) Guam, Port Moresby") },
  { value: "Australia/Hobart", label: i18n.t("(UTC+10:00) Hobart") },
  { value: "Asia/Vladivostok", label: i18n.t("(UTC+10:00) Vladivostok") },
  { value: "Australia/Lord_Howe", label: i18n.t("(UTC+10:30) Lord Howe Island") },
  { value: "Pacific/Bougainville", label: i18n.t("(UTC+11:00) Bougainville Island") },
  { value: "Asia/Srednekolymsk", label: i18n.t("(UTC+11:00) Chokurdakh") },
  { value: "Asia/Magadan", label: i18n.t("(UTC+11:00) Magadan") },
  { value: "Pacific/Norfolk", label: i18n.t("(UTC+11:00) Norfolk Island") },
  { value: "Asia/Sakhalin", label: i18n.t("(UTC+11:00) Sakhalin") },
  { value: "Pacific/Guadalcanal", label: i18n.t("(UTC+11:00) Solomon Islands, New Caledonia") },
  { value: "Asia/Anadyr", label: i18n.t("(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky") },
  { value: "Pacific/Auckland", label: i18n.t("(UTC+12:00) Auckland, Wellington") },
  { value: "Pacific/Fiji", label: i18n.t("(UTC+12:00) Fiji Islands") },
  { value: "Pacific/Chatham", label: i18n.t("(UTC+12:45) Chatham Islands") },
  { value: "Pacific/Tongatapu", label: i18n.t("(UTC+13:00) Nuku'alofa") },
  { value: "Pacific/Apia", label: i18n.t("(UTC+13:00) Samoa") },
  { value: "Pacific/Kiritimati", label: i18n.t("(UTC+14:00) Kiritimati Island") },
];
